(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- scrollers (brands, products, categories) ---------- */
  function scroller(root) {
    var track = $('[data-mx-track]', root);
    if (!track) return;
    var prev = $('[data-mx-prev]', root), next = $('[data-mx-next]', root), dots = $('[data-mx-dots]', root);
    function step() {
      var c = Array.prototype.find.call(track.children, function (x) { return !x.hidden; });
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return c ? Math.max(c.getBoundingClientRect().width + gap, track.clientWidth * 0.8) : track.clientWidth * 0.8;
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    function upd() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      root.classList.toggle('mx-static', max <= 0);
      if (dots) {
        var pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth - 0.05));
        if (dots.children.length !== pages) {
          dots.innerHTML = '';
          for (var i = 0; i < pages; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to page ' + (i + 1));
            (function (k) { b.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); })(i);
            dots.appendChild(b);
          }
        }
        var cur = Math.min(pages - 1, Math.round(track.scrollLeft / track.clientWidth));
        if (track.scrollLeft >= max) cur = pages - 1;
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === cur); });
      }
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    root._mxUpd = upd;
    upd();
  }
  $$('[data-mx-scroller]').forEach(scroller);

  /* ---------- brand filter ---------- */
  $$('[data-mx-brandfilter]').forEach(function (bf) {
    var target = document.getElementById(bf.getAttribute('data-mx-brandfilter'));
    if (!target) return;
    var track = $('[data-mx-track]', target);
    var items = track ? Array.prototype.slice.call(track.children) : [];
    var tiles = $$('[data-mx-vendor]', bf);
    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        var v = t.getAttribute('data-mx-vendor');
        tiles.forEach(function (x) { x.classList.toggle('on', x === t); x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        items.forEach(function (it) { it.hidden = !(v === 'all' || it.getAttribute('data-vendor') === v); });
        if (track) track.scrollTo({ left: 0 });
        target._mxUpd && target._mxUpd();
      });
    });
  });

  /* ---------- dialogs ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mx-open]');
    if (o) { var d = document.getElementById(o.getAttribute('data-mx-open')); if (d && d.showModal) { e.preventDefault(); d.showModal(); } }
    var c = e.target.closest('[data-mx-close]');
    if (c) { var dd = c.closest('dialog'); dd && dd.close(); }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('mx-dlg')) e.target.close();
  });
  function reopenAfterPost(formId, dlgId) {
    if (/contact_posted=true/.test(location.search) && location.hash === '#' + formId) {
      var d = document.getElementById(dlgId); if (d && d.showModal) d.showModal();
    }
    var f = document.getElementById(formId);
    if (f && f.querySelector('.mx-err')) { var d2 = document.getElementById(dlgId); if (d2 && d2.showModal) d2.showModal(); }
  }
  reopenAfterPost('MxChatForm', 'mxChat');
  reopenAfterPost('MxReviewForm', 'mxReview');

  /* ---------- chat: use an installed live-chat app first, else our message panel ---------- */
  function openLiveChat() {
    try {
      if (window.tidioChatApi) { window.tidioChatApi.show && window.tidioChatApi.show(); window.tidioChatApi.open(); return true; }
      if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') { window.Tawk_API.maximize(); return true; }
      if (window.$crisp) { window.$crisp.push(['do', 'chat:open']); return true; }
      if (window.$chatway && typeof window.$chatway.openChatwayWidget === 'function') { window.$chatway.openChatwayWidget(); return true; }
      if (window.HubSpotConversations && window.HubSpotConversations.widget) { window.HubSpotConversations.widget.open(); return true; }
      var inbox = document.querySelector('inbox-online-store-chat');
      if (inbox && inbox.shadowRoot) { var b = inbox.shadowRoot.querySelector('button'); if (b) { b.click(); return true; } }
    } catch (err) {}
    return false;
  }
  $$('[data-mx-chat]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (openLiveChat()) return;
      var d = document.getElementById('mxChat');
      if (d && d.showModal) d.showModal();
    });
  });

  /* ---------- compare models ---------- */
  $$('[data-mx-cmp]').forEach(function (root) {
    var dataEl = $('script[type="application/json"]', root), dlg = $('dialog', root), body = $('[data-mx-cmp-body]', root);
    if (!dataEl || !dlg || !body) return;
    var items; try { items = JSON.parse(dataEl.textContent); } catch (e) { items = []; }
    if (items.length < 2) { root.hidden = true; return; }
    var labels = [['model', 'Model'], ['cap', 'Size'], ['fit', 'Best for'], ['eff', 'Efficiency'], ['out', 'Heating output'], ['inp', 'Input'], ['flow', 'Max flow rate'], ['vent', 'Venting'], ['stage', 'Stages'], ['dim', 'Dimensions (in)'], ['war', 'Warranty'], ['price', 'Installed price']]
      .filter(function (l) { return items.some(function (i) { return i[l[0]]; }); });
    var sel = [];
    function cols() { return Math.min(window.innerWidth < 600 ? 2 : 3, items.length); }
    function render() {
      var n = cols();
      while (sel.length < n) { var k = 0; while (sel.indexOf(k) > -1) k++; sel.push(k); }
      sel = sel.slice(0, n);
      var h = '<div class="mx-cmp-heads" style="--n:' + n + '">';
      sel.forEach(function (idx, c) {
        var it = items[idx];
        h += '<div class="mx-cmp-head"><div class="img">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<label class="mx-vh" for="mxc' + c + '">Model ' + (c + 1) + '</label><select id="mxc' + c + '" data-col="' + c + '">' +
          items.map(function (o, k) { return '<option value="' + k + '"' + (k === idx ? ' selected' : '') + '>' + esc(o.t) + '</option>'; }).join('') +
          '</select><a class="mx-link" href="' + esc(it.url) + '">Learn more</a></div>';
      });
      h += '</div>';
      labels.forEach(function (l) {
        h += '<div class="mx-cmp-row"><div class="mx-cmp-label">' + l[1] + '</div><div class="mx-cmp-vals" style="--n:' + n + '">' +
          sel.map(function (i) { return '<div>' + esc(items[i][l[0]] || '—') + '</div>'; }).join('') + '</div></div>';
      });
      body.innerHTML = h;
      $$('select', body).forEach(function (s) { s.addEventListener('change', function () { sel[+s.getAttribute('data-col')] = +s.value; render(); var ns = document.getElementById(s.id); ns && ns.focus(); }); });
    }
    $$('[data-mx-cmp-open]', root).forEach(function (b) { b.addEventListener('click', function () { render(); dlg.showModal(); }); });
  });

  /* ---------- postal code finder ---------- */
  $$('[data-mx-finder]').forEach(function (root) {
    var areas; try { areas = JSON.parse($('script[type="application/json"]', root).textContent); } catch (e) { areas = []; }
    var inp = $('input', root), out = $('[data-mx-result]', root), form = $('form', root);
    if (!inp || !out || !form) return;
    function clear() { out.innerHTML = ''; out.className = 'mx-find-res'; }
    function run() {
      var v = inp.value.toUpperCase().replace(/\s+/g, '');
      if (v.length < 3) { clear(); return; }
      var fsa = v.slice(0, 3);
      if (!/^[A-Z]\d[A-Z]$/.test(fsa)) { out.className = 'mx-find-res bad'; out.innerHTML = 'Please enter a valid Canadian postal code, like M1B 2K3.'; return; }
      var hit = null;
      areas.forEach(function (a) { if (!hit && (' ' + a.f + ' ').indexOf(' ' + fsa + ' ') > -1) hit = a; });
      if (hit) {
        out.className = 'mx-find-res ok';
        var when = hit.d ? 'Call <a href="' + esc(root.getAttribute('data-tel')) + '">' + esc(root.getAttribute('data-phone')) + '</a> to confirm install timing for your address.' : 'Same-day installs are often available.';
        out.innerHTML = '<strong>Good news, we serve ' + esc(hit.c) + '!</strong> ' + when + '<span class="acts"><a class="mx-btn mx-btn-dark" href="/collections/all">Shop systems</a>' + (hit.u ? '<a class="mx-link" href="' + esc(hit.u) + '">' + esc(hit.c) + ' details</a>' : '') + '</span>';
      } else {
        out.className = 'mx-find-res no';
        out.innerHTML = '<strong>' + fsa + ' may be outside our regular service area.</strong> Call <a href="' + esc(root.getAttribute('data-tel')) + '">' + esc(root.getAttribute('data-phone')) + '</a> and we\'ll tell you if we can help.';
      }
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    inp.addEventListener('input', function () { if (inp.value.replace(/\s/g, '').length >= 3) run(); else clear(); });
  });

  /* ---------- FAQ: categories, search, single-open accordions ---------- */
  $$('[data-mx-faq]').forEach(function (root) {
    var groups = $$('[data-mx-faq-group]', root), cats = $$('[data-mx-faq-cat]', root), q = $('[data-mx-faq-search]', root), none = $('[data-mx-faq-none]', root), list = $('[data-mx-faq-list]', root), active = 'all';
    function apply() {
      var term = (q && q.value || '').trim().toLowerCase(), any = false;
      groups.forEach(function (g) {
        var inCat = active === 'all' || g.getAttribute('data-mx-faq-group') === active, shown = 0;
        $$('details', g).forEach(function (d) {
          var ok = inCat && (!term || d.textContent.toLowerCase().indexOf(term) > -1);
          d.hidden = !ok; if (ok) shown++;
          if (term && ok && shown === 1) d.open = true;
        });
        g.hidden = !shown; if (shown) any = true;
      });
      if (none) none.hidden = any;
    }
    cats.forEach(function (c) {
      c.addEventListener('click', function () {
        var id = c.getAttribute('data-mx-faq-cat');
        active = active === id ? 'all' : id;
        cats.forEach(function (x) { var on = x.getAttribute('data-mx-faq-cat') === active; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        if (q) q.value = '';
        apply();
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    q && q.addEventListener('input', apply);
    var form = q && q.closest('form'); form && form.addEventListener('submit', function (e) { e.preventDefault(); apply(); if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    $$('details', root).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open && !(q && q.value)) $$('details', d.parentElement).forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    var h = location.hash.slice(1);
    if (h) { var hit = cats.filter(function (x) { return x.getAttribute('data-mx-faq-cat') === h; })[0]; hit && hit.click(); }
  });
})();